import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Auth } from "./modules/auth/Auth";
import { Home } from "./modules/home/Home";
import PageNotFound from "./modules/shared/presentations/PageNotFound";

export const AppRoutes = () => {
  return (
    <Switch>
      <Route path="/auth" ><Auth /></Route>
      <Route path="/home" ><Home/></Route>
      <Redirect path={'/'} to={'/auth'}></Redirect>
      <Route component={PageNotFound} />
    </Switch>
  );
};